module.exports = __webpack_public_path__ + "static/media/money.e81de955.svg";